import React, { memo } from "react";
import styles from "./FinalizationHeader.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";
import { useTenant } from "../../../tenant/branding/useTenant";
import { TenantLogo } from "../../../tenant/branding/TenantLogo";

type Props = {
	onClickSideMenu: () => void;
};

const FinalizationHeader: React.FC<Props> = memo((props: Props) => {
	const { onClickSideMenu } = props;

	const navigate = useNavigate();
	const location = useLocation();
	const { logoWithText } = useTenant();

	const landingRouteChange = () => {
		const path = location.pathname;
		// Utility-admin secret contains the admin secret as a substring, so check it FIRST.
		if (ApplicationRoutes.ADMIN_UTIL_SECRET && path.includes(ApplicationRoutes.ADMIN_UTIL_SECRET)) {
			navigate(`/${ApplicationRoutes.ADMIN_UTIL_BASE}`);
		} else if (ApplicationRoutes.ADMIN_SECRET && path.includes(ApplicationRoutes.ADMIN_SECRET)) {
			navigate(`/${ApplicationRoutes.ADMIN_BASE}`);
		} else {
			navigate(ApplicationRoutes.LANDING_PAGE);
		}
	};

	const routeChange = () => {
		navigate(`/${ApplicationRoutes.LOGIN}`);
	};

	const partnersRouteChange = () => {
		navigate(`/${ApplicationRoutes.PROVIDER_SIGNUP}`);
	};

	return (
		<div className={styles.container}>
			<TenantLogo logo={logoWithText} alt="Logo" className={styles.homeLink} onClick={landingRouteChange} />
			<div className={styles.links}>
				{/* <div className={styles.link}>
          About
        </div> */}
				<button className={`standardButton ${styles.link}`} onClick={partnersRouteChange}>
					Partner Signup
				</button>
				{/* <button className={`standardButton ${styles.button}`} onClick={routeChange}>
          Sign In
        </button> */}
			</div>
			<button className={styles.menuButton} onClick={onClickSideMenu}>
				<img src="../../../icons/menu_icon.svg" alt="Menu" />
			</button>
		</div>
	);
});

export default FinalizationHeader;
